// Device detection: returns true if desktop, false if mobile/tablet
function isDesktop() {
  const ua = navigator.userAgent;
  return !/Mobi|Android|iPad|iPhone|iPod|Tablet|Mobile/i.test(ua);
}

function marqueeEqualSpeed() {
  const runTextArray = document.querySelectorAll(".our-people__marquee");
  if (runTextArray.length === 0) return;
  runTextArray.forEach((el) => {
    let runTextLength = el.getBoundingClientRect().width;
    let speed = runTextLength / 85;
    el.style.animationDuration = speed + "s";
  });
}

function animateNumberReveal(selector) {
  const items = document.querySelectorAll(selector);

  if (items.length === 0) return;

  function getRandomCharacter() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  function animateNumbers(item) {
    const targetNumber = item.innerText;

    // Create a document fragment to batch DOM manipulations
    const fragment = document.createDocumentFragment();

    // Split the target number into spans and append to the fragment
    targetNumber.split("").forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char; // Initially set to the target number
      fragment.appendChild(span);
    });

    // Append the fragment to the item
    item.innerHTML = ""; // Clear the original text
    item.appendChild(fragment);
    const numberSpans = item.querySelectorAll("span"); // Get spans after appending
    numberSpans.forEach((span, index) => {
      const randomInterval = setInterval(() => {
        span.textContent = getRandomCharacter();
      }, 50);

      // Stop the randomization after a certain time and set the final number
      setTimeout(
        () => {
          clearInterval(randomInterval);
          span.textContent = targetNumber[index]; // Set to the original character
        },
        700 + index * 200, // Stagger the reveal for each character
      );
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });

  items.forEach((item) => {
    observer.observe(item);
  });
}

function wrapSupWithSpan(selector) {
  const heading = document.querySelector(selector);
  const sup = heading.querySelector("sup");

  if (sup && sup.previousSibling?.nodeType === Node.TEXT_NODE) {
    const textNode = sup.previousSibling;
    const text = textNode.textContent.trim();

    // Split off the last word before <sup>
    const words = text.split(/\s+/);
    const lastWord = words.pop();
    const beforeText = words.join(" ");

    // Create span with inline-block style
    const span = document.createElement("span");
    span.style.display = "inline-block";
    span.textContent = lastWord + " ";
    span.appendChild(sup);

    // Rebuild DOM
    const parent = textNode.parentNode;
    if (beforeText) {
      parent.insertBefore(document.createTextNode(beforeText + " "), textNode);
    }
    parent.insertBefore(span, textNode);
    parent.removeChild(textNode);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  animateNumberReveal(".jsCounter");
});

window.addEventListener("load", function () {
  marqueeEqualSpeed();
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({
    autoRefreshEvents: "DOMContentLoaded,load,visibilitychange",
  });

  // Initialize scroll reveal animations
  if (typeof window.initScrollReveal === "function") {
    window.initScrollReveal();
  }
  if (typeof window.initScrollRevealTrigger === "function") {
    setTimeout(() => {
      window.initScrollRevealTrigger();
    }, 300);
  }

  if (isDesktop()) {
    const heroGlobe = document.querySelector(".hero-globe");
    if (heroGlobe) {
      heroGlobe.classList.add("hero-globe--hover");
    }
  }

  // Initialize vertical carousel animation
  setTimeout(() => {
    verticalCarouselAnimation();
  }, 100);

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {}, 100);
  });
});
function verticalCarouselAnimation() {
  const section = document.querySelector(".section--vertical-carousel");
  const items = gsap.utils.toArray(".vertical-carousel__item");
  const hgroup = document.querySelector(".vertical-carousel__left");

  if (!section || items.length === 0) {
    console.warn("Vertical carousel: Section or items not found");
    return;
  }

  // Stabilize the hgroup/h2 element to prevent jerking
  if (hgroup) {
    gsap.set(hgroup, {
      force3D: true,
      backfaceVisibility: "hidden",
      transform: "translateZ(0)",
    });
  }

  // Kill any existing ScrollTriggers on this section
  ScrollTrigger.getAll().forEach((trigger) => {
    if (trigger.trigger === section) {
      trigger.kill();
    }
  });

  const lastItemIndex = items.length - 1;

  // Set initial states for all items with equal spacing
  // Calculate equal spacing: from 40% (center) to 100% (bottom) = 60% divided by (items.length - 1) gaps
  const centerPosition = 40;
  const spacing = (100 - centerPosition) / (items.length - 1); // Equal spacing between items

  items.forEach((item, i) => {
    gsap.set(item, {
      opacity: i === 0 ? 1 : 0.5,
      top: `${centerPosition + spacing * i}%`, // Equal spacing: 40%, 70%, 100%
      willChange: "transform, opacity",
    });
  });

  // Create the main pinned ScrollTrigger
  ScrollTrigger.create({
    trigger: section,
    start: "center center",
    end: `+=${lastItemIndex * 150}vh`, // Increased from 100vh to 150vh for slower movement
    pin: true,
    pinSpacing: true,
    scrub: 2.5, // Higher value = slower, smoother animation (was 3, now 2.5 for better balance)
    anticipatePin: 1,
    invalidateOnRefresh: true,
    onUpdate: (self) => {
      const progress = self.progress;
      const totalProgress = progress * lastItemIndex;

      items.forEach((item, i) => {
        const distance = totalProgress - i;
        let topPosition;
        let opacity;

        if (i === lastItemIndex) {
          // Last item
          if (distance <= 0) {
            const itemProgress = Math.max(-1, distance * 0.5) + 1; // 0 to 1
            topPosition = `${100 - 60 * itemProgress}%`; // Moves from 100% to 40%
            opacity = Math.max(0, 1 + distance);
          } else {
            topPosition = "40%";
            opacity = 1;
          }
        } else {
          // Other items - slow down movement for first and second items
          if (distance <= 0) {
            // Item is coming up
            // Slow down first item (i=0) by 50%, second item (i=1) by 50%
            const adjustedDistance =
              i === 0 || i === 1 ? distance * 0.5 : distance;
            const itemProgress = Math.max(-1, adjustedDistance) + 1; // 0 to 1
            topPosition = `${100 - 60 * itemProgress}%`; // Moves from 100% to 40%
            opacity = Math.max(0, 1 + adjustedDistance);
          } else {
            // Item has passed center
            // Slow down first item (i=0) by 40%, second item (i=1) by 40%
            const adjustedDistance =
              i === 0 || i === 1 ? distance * 0.6 : distance;
            const itemProgress = Math.min(1, adjustedDistance); // 0 to 1
            topPosition = `${40 - 40 * itemProgress}%`; // Moves from 40% to 0%
            opacity = Math.max(0, 1 - adjustedDistance);
          }
        }

        gsap.to(item, {
          opacity: opacity,
          top: topPosition,
          ease: "linear",
          overwrite: "auto",
        });
      });
    },
    onRefresh: () => {
      // Recalculate positions on refresh
      items.forEach((item, i) => {
        const currentProgress =
          ScrollTrigger.getAll().find((st) => st.trigger === section)
            ?.progress || 0;
        const totalProgress = currentProgress * (lastItemIndex + 0.5); // Match the onUpdate calculation
        const distance = totalProgress - i;

        if (distance <= 0) {
          const adjustedDistance =
            i === 0 || i === 1 ? distance * 0.5 : distance;
          const itemProgress = Math.max(-1, adjustedDistance) + 1;
          gsap.set(item, {
            opacity: Math.max(0, 1 + adjustedDistance),
            top: `${100 - 60 * itemProgress}%`,
          });
        } else {
          const adjustedDistance =
            i === 0 || i === 1 ? distance * 0.6 : distance;
          const itemProgress = Math.min(1, adjustedDistance);
          gsap.set(item, {
            opacity: Math.max(0, 1 - adjustedDistance),
            top: `${40 - 40 * itemProgress}%`,
          });
        }
      });
    },
  });
}
window.addEventListener("mousemove", function (e) {
  const globeCanvas = document.querySelector(".globe__canvas");
  if (!globeCanvas) return;

  const rect = globeCanvas.getBoundingClientRect();

  // Calculate percentages (0-100)
  const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
  const yPercent = ((e.clientY - rect.top) / rect.height) * 100;

  // Calculate how far the cursor is from center (in percentage units)
  // Center is at 50%, so distance ranges from -50 to +50
  const centerOffsetX = xPercent - 50;
  const centerOffsetY = yPercent - 50;

  // Calculate final position
  // When cursor is at center (50%), x will be 50%
  // When cursor is at edges, x will move less due to the subtraction
  const x = xPercent + centerOffsetX * 0.5; // Adjust the 0.5 multiplier as needed
  const y = yPercent + centerOffsetY * 0.5; // Smaller values = less correction

  globeCanvas.style.setProperty("--data-mouse-x", `${x}%`);
  globeCanvas.style.setProperty("--data-mouse-y", `${y}%`);
});

let prevWidth = window.innerWidth;
window.addEventListener("resize", function () {
  let currentWidth = window.innerWidth;
  if (currentWidth !== prevWidth) {
    prevWidth = currentWidth;
    setTimeout(function () {
      // ScrollTrigger.refresh();
    }, 150);
  }
});

window.addEventListener("orientationchange", function () {
  setTimeout(() => {
    // ScrollTrigger.refresh();
  }, 200);
});
